import React from 'react'
import PropTypes from 'prop-types'
import Page from '../../../../internal/Page'

const InfoESkatMandatory = ({ title }) => (
  <Page title={title} type="info">
    <h4 style={{ margin: '2rem' }}>Informer kunden:</h4>
    <p style={{ margin: '2rem', lineHeight: '1.5em' }}>
      For at kunne bruge denne betalingsmetode skal du udfylde et
      ansøgningsskema, give samtykke til eSkat, KreditStatus og Kreditvurdering,
      dette er obligatorisk.
    </p>
  </Page>
)

InfoESkatMandatory.propTypes = {
  title: PropTypes.string,
}

InfoESkatMandatory.defaultProps = {
  title: null,
}

export default InfoESkatMandatory
